///
/// Copyright (c) 2017-present, Siklu Ltd.
/// All rights reserved.
///

import { Injectable } from '@angular/core';

// Any changes in this enum must be reflected in the service auto-logout-worker.js
export enum MessageType {
    LOGIN = 'login',
    LOGOUT = 'logout',
    COUNTDOWN = 'countdown',
    TIMER_RESET = 'reset-timer',
    AUTO_LOGOUT = 'auto-logout',
    STOP_TIMERS = 'stop-timers',
    USER_ACTIVITY = 'user-activity'
}

@Injectable({ providedIn: 'root' })
export class AutoLogoutWorkerService {
    addMessageListener(callback: (event: MessageEvent) => void): void {
        if ('serviceWorker' in navigator) {
            navigator.serviceWorker.addEventListener('message', callback);
        }
    }

    postMessage(message: { type: MessageType }) {
        if ('serviceWorker' in navigator) {
            navigator.serviceWorker.controller?.postMessage(message);
        }
    }
}
